<template>
  <div></div>
</template>

<script setup>
import { onMounted } from 'vue'

/*const props =*/ defineProps({
  sticky: Boolean
})

onMounted(async () => {
  console.log('*** MenuNoButton')
  // const menu = document.querySelector('.rhg-menu-secondary');
  // if (menu && props.sticky) {
  //   menu.classList.add('rhg-menu-secondary--sticky');
  // }
})
</script>
